var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { ReflectUtils } from "@dooboostore/core";
import { SwcUtils } from "../utils/Utils.js";
import { buildSwcParameterArgs, buildCommonKindValues } from "./parameter.js";
const EVENT_MEDIA_METADATA_KEY = Symbol.for("simple-web-component:event-media");
function eventMedia(query, eventType, options) {
  return (target, propertyKey) => {
    const constructor = target.constructor;
    let metaList = ReflectUtils.getOwnMetadata(EVENT_MEDIA_METADATA_KEY, constructor);
    if (!metaList) {
      metaList = [];
      ReflectUtils.defineMetadata(EVENT_MEDIA_METADATA_KEY, metaList, constructor);
    }
    metaList.push({ propertyKey, query, eventType, filter: options?.filter, before: options?.before, finally: options?.finally });
  };
}
function eventMediaChange(query, options) {
  return eventMedia(query, "change", options);
}
const findAllEventMediaMetadata = (target) => {
  const constructor = typeof target === "function" ? target : target.constructor;
  return (ReflectUtils.findAllMetadata(EVENT_MEDIA_METADATA_KEY, constructor) || []).flat();
};
class EventMediaLifeCycler {
  constructor() {
    __publicField(this, "entriesMap", /* @__PURE__ */ new WeakMap());
  }
  onConnected(helperHostSet) {
    const inst = helperHostSet.$this;
    const metaList = findAllEventMediaMetadata(inst);
    if (metaList.length === 0) return;
    const win = helperHostSet.$w;
    const entries = [];
    for (const meta of metaList) {
      const mql = win.matchMedia(meta.query);
      const handler = async (e) => {
        try {
          const helper = SwcUtils.getHelperAndHostSet(inst);
          if (meta.filter && !await meta.filter(e, { currentThis: inst, helper })) return;
          const common = buildCommonKindValues(inst, win);
          const legacyArgs = [e, helperHostSet];
          const buildArgs = (beforeReturn) => buildSwcParameterArgs(inst, meta.propertyKey, {
            ...common,
            eventObject: e,
            eventMediaBeforeReturn: beforeReturn
          }, legacyArgs);
          let args = buildArgs(void 0);
          if (meta.before) {
            const beforeReturn = await meta.before(e, { currentThis: inst, helper }, args);
            args = buildArgs(beforeReturn);
          }
          let result, error;
          try {
            result = await inst[meta.propertyKey](...args);
          } catch (err) {
            error = err;
          } finally {
            if (meta.finally) await meta.finally(e, { currentThis: inst, helper }, { args, result, error });
          }
          if (error) throw error;
        } catch (err) {
          console.error("[SWC] eventMedia handler error:", err);
        }
      };
      mql.addEventListener(meta.eventType, handler);
      entries.push({ mql, eventType: meta.eventType, handler });
    }
    this.entriesMap.set(inst, entries);
  }
  onDisconnected(helperHostSet) {
    const inst = helperHostSet.$this;
    for (const { mql, eventType, handler } of this.entriesMap.get(inst) ?? []) {
      try {
        mql.removeEventListener(eventType, handler);
      } catch (e) {
        console.error("[SWC] eventMedia cleanup error:", e);
      }
    }
    this.entriesMap.delete(inst);
  }
}
export {
  EVENT_MEDIA_METADATA_KEY,
  EventMediaLifeCycler,
  eventMedia,
  eventMediaChange,
  findAllEventMediaMetadata
};
//# sourceMappingURL=eventMedia.js.map
